(function () {
	'use strict';

	angular
		.module('app.setup', ['ui.bootstrap', 'pascalprecht.translate', 'smart-table', 'angularutilities', 'smarttableutilities', 'angular-transfer-box']);
})();